export const SINGLE_COURSE_LENGTH = 320;
export const SINGLE_COURSE_SEED = 240514;
